
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    href: {
      default: undefined,
      type: String as PropType<string>
    },
    variant: {
      required: true,
      type: String as PropType<'number' | 'operation' | 'clear'>
    }
  }
})
